<template>
  <div class="h-100">
    <div class="horizontal-scroll info">
      <h3 class="c-white" v-if="busy">{{$t('settings.mail.wait')}}</h3>
      <div v-if="!busy">
        <h3
          class="c-green"
          v-if="success"
        >{{$t('settings.mail.changed')}}</h3>
        <h3 class="c-red" v-if="!success">
            {{$t('settings.mail.errorl')}}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import AuthAPI from "@/api/auth";

export default {
  data() {
    return {
      busy: true,
      success: false
    };
  },
  methods: {
    sendRequest() {
      AuthAPI.confirmEmailChange(this.$route.params.key)
        .then(data => {
          this.busy = false;
          this.success = true;

          const vm = this;

          setTimeout(() => {
            this.$router.push("/");
            window.location.reload();
          }, 3000);
        })
        .catch(error => {
          this.busy = false;
          this.success = false;
        });
    }
  },
  mounted() {
    this.sendRequest();
  }
};
</script>

<style scoped>

.info {
    margin-top: 5vh;
}
</style>